const DownArrow: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="10"
    height="10"
    id="arrow-down"
    viewBox="0 0 18.23 11.18"
    className={className}
  >
    <path d="M17.53,3.79c.88-.77,.93-2.14,.16-3.01s-2.14-.93-3.01-.16l-5.53,4.87L3.57,.56C2.69-.26,1.32-.15,.56,.72-.26,1.6-.15,2.97,.72,3.73l8.43,7.45L17.53,3.79Z" />
  </svg>
);

export default DownArrow;
